import { Icon, IconProps } from '@chakra-ui/react'

export const CheckOutlineIcon = ({ ...props }: IconProps) => {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <g clipPath="url(#clip0_627_3621)">
      <path
        d="M27.2933 7.50669C27.8133 8.02669 27.8133 8.85336 27.2933 9.37336L12.1733 24.4934C11.6533 25.0134 10.8266 25.0134 10.3066 24.4934L4.70664 18.8934C4.18664 18.3734 4.18664 17.5467 4.70664 17.0267C5.22664 16.5067 6.05331 16.5067 6.57331 17.0267L11.24 21.6934L25.4266 7.50669C25.9466 6.98669 26.7733 6.98669 27.2933 7.50669ZM24.48 4.68002L11.24 17.92L7.51998 14.2C6.47998 13.16 4.78664 13.16 3.74664 14.2L1.87998 16.0667C0.839976 17.1067 0.839976 18.8 1.87998 19.84L9.34664 27.3067C10.3866 28.3467 12.08 28.3467 13.12 27.3067L30.12 10.32C31.16 9.28002 31.16 7.58669 30.12 6.54669L28.2533 4.68002C27.2 3.64002 25.52 3.64002 24.48 4.68002V4.68002Z"
        fill="currentColor"
      />
      </g>
      <defs>
      <clipPath id="clip0_627_3621">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
    </Icon>
  )
}
